import { FormProvider, useForm } from "react-hook-form";
import { DocumentFormProps } from "./ValidationModal";
import { Box, Stack, TextField, Button } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import yup from "core/validation/yup-config";
import FieldDatepicker from "components/forms/fields/FieldDatepicker";

const schema = yup.object().shape({
  first_name: yup.string().required(),
  last_name: yup.string().required(),
  social_security_number: yup.string().required(),
  issue_date: yup.string().required(),
});

const SSNCardDocumentForm = ({ document, onApprove, onReject, disabled }: DocumentFormProps) => {
  const methods = useForm<any>({
    mode: 'onBlur',
    defaultValues: document.ocr_data,
    resolver: yupResolver(schema)
  });
  const { register, formState: { errors }, handleSubmit } = methods;

  return (
    <Box sx={{ height: '100%' }}>
      <FormProvider {...methods}>
        <Stack justifyContent="space-between" height="90%">
          <Stack gap={2}>
            <Stack direction="row" justifyContent="space-between" gap={2}>
              <TextField disabled={disabled} sx={{ backgroundColor: 'white' }} label="Nom *" {...register('last_name')} error={!!errors.last_name} />
              <TextField disabled={disabled} sx={{ backgroundColor: 'white' }} label="Prénom *" {...register('first_name')} error={!!errors.first_name} />
            </Stack>
            <Stack direction="row" justifyContent="space-between" gap={2}>
              <TextField disabled={disabled} sx={{ backgroundColor: 'white' }} label="Numéro de sécurité sociale *" {...register('social_security_number')} error={!!errors.ssn_number} />
              <FieldDatepicker disabled={disabled} fieldName="issue_date" label="Date de délivrance *" control={methods.control} sx={{ backgroundColor: 'white' }} />
            </Stack>
          </Stack>

          {!disabled && (
            <Stack direction="row" justifyContent="space-between" gap={2} mt={4}>
              <Button variant="outlined" color="error" onClick={onReject}>Refuser le document</Button>
              <Button variant="contained" color="primary" onClick={handleSubmit(onApprove)}>Valider</Button>
            </Stack>
          )}
        </Stack>
      </FormProvider>
    </Box>
  );
};

export default SSNCardDocumentForm;